import React, { useState } from 'react';
import truncate from 'lodash/truncate';

import ListResource from './ListResource.jsx';
import ListCompSelect from './ListCompSelect.jsx';

const api = 'api/quiz/scores/questions';

const ListScores = () => {
  const [compFilter, setCompFilter] = useState({});

  return (
    <ListResource
      {...{
        // searchable: true,
        api,
        sort: { 'question.qSetCode': 1 },
        filter: { ...compFilter },
        actions: {
          find: false,
          create: false,
          remove: false,
          fileExport: 'export',
        },
        ctrls: [
          <ListCompSelect
            key={0}
            value={compFilter}
            onChange={setCompFilter}
            questionSet
          />,
        ],
        cols: [
          {
            key: 'question.qSetCode',
            children: 'Subject',
            sortable: true,
          },
          {
            key: 'question.refCode',
            children: 'Code',
            sortable: true,
          },
          {
            key: 'question.question',
            children: 'Question',
            getter: (v) => truncate(v, 15),
          },
          {
            key: 'answered',
            children: (
              <span title="Number of times the question has been drawn randomly">
                Picked *
              </span>
            ),
            sortable: true,
          },
          {
            key: 'isCorrect',
            children: 'Correct',
            sortable: true,
          },
          {
            key: 'correctPct',
            children: 'Correct %',
            sortable: true,
            getter: (v) => (v !== 'na'
              ? `${Math.round(v * 100 * 100) / 100}%` : 'N/A'
            ),
          },
        ],
      }}
    />
  );
};

export default ListScores;
